<ng-container *transloco="let t">
  <div class="flex flex-col gap-4">
    <div class="form-group row items-center">
      <span class="prepend col-4">{{ t("update-custom-campaign-name.custom_campaign_naming") }}</span>
      <div class="col-8">
        <IToggle [(checked)]="canEdit" />
      </div>
    </div>
    @if (canEdit()) {
      @if (edit) {
        <IFormField>
          <label iLabel>{{ t("update-custom-campaign-name.campaign_name_pattern") }}</label>
          <input
            iInput
            [(ngModel)]="customCampaignName"
            class="w-full"
            [placeholder]="t('update-custom-campaign-name.campaign_name_pattern')"
            [maxLength]="256"
            (keydown.enter)="validPattern() && update()"
          />
        </IFormField>
      }
      @if (!edit) {
        <div class="flex items-center gap-2">
          <div
            [innerHTML]="
              (customCampaignNameHighlighted !== null ? customCampaignNameHighlighted : '')
                | customCampaignNameHighlightPipe
            "
          ></div>

          <button iButton variant="ghost" size="sm" (click)="setEditCustomCampaignName()">
            {{ t("common.edit") }}
          </button>
        </div>
      }
      <div class="mt-4">
        <span> {{ t("update-custom-campaign-name.customize_tokens") }} </span>
        <ul class="p-4">
          @for (token of CustomCampaignNameTokens; track token) {
            <li class="pointer my-1">
              <a (click)="addTokenToInput(token)" class="hover:underline">
                <code>{{ token }}</code>
              </a>
            </li>
          }
        </ul>
      </div>
    }
  </div>
  <div class="flex justify-end gap-2">
    <button iButton variant="secondary" (click)="modalRef.close()">
      {{ t("common.cancel") }}
    </button>

    <button iButton type="submit" [disabled]="!validPattern()" (click)="update()">
      {{ t("common.update") }}
    </button>
  </div>
</ng-container>
